import { ButtonProps } from '~/components';
import { FormSubmitButton } from '~/components/form';

export const FormSubmit = ({
  label,
  onSubmit,
  isLoading,
}: {
  label?: string;
  onSubmit?: ButtonProps['onClick'];
  isLoading: boolean;
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-10 border-t bg-background/80 p-4 backdrop-blur-md md:py-6 lg:left-72">
      <div className="mx-auto w-40 md:w-52">
        <FormSubmitButton
          isLoading={isLoading}
          label={label || 'Save'}
          onClick={onSubmit}
          variant="secondary"
        />
      </div>
    </div>
  );
};
